import React from "react"

import * as styles from "./video-embed-block.module.css"

const iframeRegEx =
  /<iframe[^>]*src=["']https?:\/\/[-a-zA-Z0-9()@:%_+.~#?&/=]*["'][^>]*><\/iframe>/

const VideoEmbedBlock = ({ data }) => {
  const iframeMatch = data?.embedCode?.embedCode?.match(iframeRegEx)
  const cleanEmbedCode = iframeMatch ? iframeMatch[0] : ""

  return (
    <div
      className={styles.wrapper}
      dangerouslySetInnerHTML={{ __html: cleanEmbedCode }}
    />
  )
}

export default VideoEmbedBlock
